// extracted by mini-css-extract-plugin
export default {"wrap":"Empty_wrap__Ptwn6"};